import { EPaymentGroup } from '@model';

import { isValidatedLastOrder, IValidatedLastOrderResponse } from '../../../model';
import { IValidatedLastOrder } from '../../../model';

/**
 * Transforms DTO data to last order with proper types.
 * @param data The DTO object.
 * @return IValidatedLastOrder The last order object.
 */
export const decodeLastOrderFromDto = (data: IValidatedLastOrderResponse): IValidatedLastOrder | null => {
  if (!data.lastOrder) return null;

  // fix delivery time
  const deliveryTime = new Date(data.lastOrder?.deliveryInfo?.deliveryTime);
  const paymentGroups = data.lastOrder.paymentInfo.paymentGroups
    ? [...(data.lastOrder.paymentInfo.paymentGroups as EPaymentGroup[])]
    : [];
  const lastOrder = {
    ...data.lastOrder,
    deliveryInfo: {
      ...data.lastOrder.deliveryInfo,
      deliveryTime,
    },
    paymentInfo: {
      ...data.lastOrder.paymentInfo,
      paymentGroups,
    },
  };
  const fixedData: IValidatedLastOrder = { ...data, lastOrder };

  // validate fixed data
  return isValidatedLastOrder(fixedData) ? fixedData : null;
};
